import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  container: {
    marginLeft: '2rem',
  },
}));

export default useStyles;
